Ext.define('SA.view.locationsearch.LocationsList', {
    alias: 'widget.location-search-field-locations-list',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-sidebar-location-results',
    floating: true,
    focusOnToFront: false,
    height: 308,
    plugins: [{ptype: 'sa-arrow', bias: 0.2}],
    width: 284,

    items: [
        {
            xtype: 'component',
            cls: 'sa-sidebar-location-results-mask',
            html: 'Searching…'
        }, {
            xtype: 'component',
            cls: 'sa-sidebar-location-results-list-wrap',
            itemId: 'resultsCt',
            visible: false,

            tpl: [
                '<div>',
                    '<tpl for="locations">',
                        '<button data-location="{id}" class="sa-sidebar-location-result<tpl if="selected"> sa-sidebar-location-result-selected</tpl>">',
                            '<span class="sa-sidebar-location-name">{name}</span>',
                            '<span class="sa-sidebar-location-unit">{geographicUnit}</span>',
                        '</button>',
                    '</tpl>',
                '</div>',
                '<tpl if="locations.length && hasLocationsByAddress">',
                    '<div class="sa-sidebar-location-results-address-search-attribution"></div>',
                '</tpl>'
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-sidebar-location-results-no-results',
            itemId: 'noResultsCt',

            items: [
                {
                    xtype: 'component',

                    html: [
                        'No matching locations found.',
                        '<div class="sa-sidebar-location-results-address-search-msg">',
                            '<strong>Trying to search by address?</strong> Enter the address above and click &ldquo;Address Search&rdquo;.',
                        '</div>'
                    ]
                }, {
                    xtype: 'sa-button',
                    autoEl: 'button',
                    text: 'Address Search',

                    handler() {
                        this.up('location-search-field-locations-list').onSearchByAddressClick();
                    }
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.resultsCt = this.down('#resultsCt');
        this.noResultsCt = this.down('#noResultsCt');

        SA.LocationsReferenceTracker.registerReferencer(this);
    },

    beforeDestroy() {
        SA.LocationsReferenceTracker.unregisterReferencer(this);

        this.callParent();
    },

    getReferencedLocations() {
        return Ext.Array.from(this.locations);
    },

    getRefOwner() {
        return this.pickerOwner;
    },

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-sidebar-location-result',
            scope: this,

            click: this.onClick,
            mouseout: this.onMouseOut,
            mouseover: this.onMouseOver
        });
    },

    onClick(ev, el) {
        var locationSeries = el.getAttribute('data-location');

        if (locationSeries) {
            this.fireEvent('select', this, locationSeries);
        }
    },

    onMouseOut(ev, el) {
        Ext.fly(el).removeCls('sa-sidebar-location-result-over');
    },

    onMouseOver(ev, el) {
        Ext.fly(el).addCls('sa-sidebar-location-result-over');
    },

    onSearchByAddressClick() {
        this.fireEvent('click:addressSearch', this);
    },

    refresh() {
        var locations = this.locations,
            fm = Ext.util.Format;

        if (!locations) {
            return;
        }

        locations = locations.map(location => {
            return {
                geographicUnit: SA.data.GeographicUnits.get(location.geographicUnit).singularName,
                id: SA.data.LocationsCache.toLocationSeries(location),
                name: fm.locationRenderer(location)
            };
        });

        this.resultsCt.update({locations, hasLocationsByAddress: this.hasLocationsByAddress});
        this.resultsCt.setVisible(locations.length);

        this.noResultsCt.setVisible(!locations.length);

        this.removeCls('sa-sidebar-location-results-masked');

        this.getPlugin('sa-arrow').refresh();
    },

    setAddressLocations(locations) {
        this.locations = locations;
        this.hasLocationsByAddress = true;

        this.refresh();
    },

    setLocations(locations) {
        this.locations = locations;
        this.hasLocationsByAddress = false;

        this.refresh();
    },

    showMask() {
        this.addCls('sa-sidebar-location-results-masked');
    }
});
